var _Glyphicon;
import { useDevice } from '@atc/react-device';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import React from 'react';
import { Glyphicon, Label, OverlayTrigger, Popover, Text } from 'reaxl';

/**
 *  Displays an inventory label indicating that the listing is likely to sell quickly
 */
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function HotCar(_ref) {
  let {
    bsStyle = 'brand',
    description,
    enableOverlay = false,
    label = 'High Demand',
    ...rest
  } = _ref;
  const device = useDevice();
  const isLg = _get(device, 'is.lg', true);
  const triggerType = isLg ? ['hover', 'focus', 'click'] : ['click'];
  const labelComponent = /*#__PURE__*/_jsxs(Label, {
    "data-cmp": "hotCar",
    bsStyle: bsStyle,
    ...rest,
    children: [label, enableOverlay && description && (_Glyphicon || (_Glyphicon = /*#__PURE__*/_jsx(Glyphicon, {
      glyph: "info",
      className: "margin-left-1 text-valign-baseline"
    })))]
  });

  // If overlay and description are enabled, wrap the label in an OverlayTrigger
  if (enableOverlay && description) {
    return /*#__PURE__*/_jsx(OverlayTrigger, {
      "aria-label": "High Demand",
      className: "cursor-pointer",
      placement: "top",
      rootClose: true,
      trigger: triggerType,
      overlay: /*#__PURE__*/_jsx(Popover, {
        id: "hot-car-description",
        children: description
      }),
      children: labelComponent
    });
  }

  // If only description is provided, display it next to the label
  if (description) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [labelComponent, /*#__PURE__*/_jsx(Text, {
        className: "margin-left-2",
        color: "subdued-lightest",
        children: description
      })]
    });
  }
  return labelComponent;
}
export default HotCar;